/* eslint-disable max-len */
import React, { useContext } from 'react';
import { Transition } from '@headlessui/react';

import { useKeyPress } from 'utils/hooks';
import { AppContext } from 'context/AppContext';

import Wizard from 'components/Wizard';
import Loading from 'components/Core/Loading';

const WizardDialog = () => {
  const appState = useContext(AppContext);

  const { showWizard = false, wizardProps = {}, updateAppState } = appState;

  const closeWizard = () => {
    document.body.classList.remove('modal-open');
    updateAppState((state) => ({
      ...state,
      showWizard: false,
    }));
  };
  useKeyPress('Escape', closeWizard);

  const { isLoading = true } = wizardProps;

  const openModal = showWizard;
  return (
    <Transition
      show={openModal}
      enter="transition-opacity duration-75"
      enterFrom="opacity-0"
      enterTo="opacity-100"
      leave="transition-opacity duration-100"
      leaveFrom="opacity-100"
      leaveTo="opacity-0"
    >
      <>
        <div className="overlay opacity-1 fixed w-full h-full top-0 left-0 flex items-center justify-center z-110">
          <div className="overlay-bg absolute w-full h-full bg-gray-900 opacity-50" />
          {isLoading ? (
            <Loading transparentBg fullHeight extraClassNames="z-120" />
          ) : (
            <Wizard {...wizardProps} extraClassNames="z-120 overflow-y-scroll" />
          )}
        </div>
      </>
    </Transition>
  );
};
export default WizardDialog;
